import React from "react";

const password = (value) => {
  if (value.length < 6 || value.length > 128) {
    return <div role="alert">Minimum 6 characters required</div>;
  }
};

export default password;
